<template>
  <div class="sidebarWrapper">
    <div class="menuWrapper">
      <div class="logoImgWrapper">
        <img class="logoImg" v-bind:src="logoImg">
        <span class="versionInfo">{{'  ver. ' + $store.getters.getVersion}}</span>
      </div>
      <main-menu v-bind="mainBoard"></main-menu>
      <main-menu v-bind="myAdvertise"></main-menu>
      <sub-menu v-bind="enroll"></sub-menu>
      <sub-menu v-bind="list"></sub-menu>
      <sub-menu v-bind="feeInfo"></sub-menu>
      <main-menu v-bind="profile"></main-menu>
      <sub-menu v-bind="myInfo"></sub-menu>
      <sub-menu v-bind="follower"></sub-menu>
    </div>
    <div class="adUserInfoWrapper">
      <div class="adUserInfoDiv">
        <img v-bind:src="thumbnail">
        <span>{{$store.getters.getAdUserStateValue('name')}}</span>
      </div>
      <div class="logoutDiv">
        <span v-on:click="logout">로그아웃</span>
      </div>
    </div>
  </div>
</template>

<script>
import mainMenu from '../../sidebar/elements/mainMenu.vue'
import subMenu from '../../sidebar/elements/subMenu'

export default {
  data () {
    return {
      logoImg: require('@/assets/img/logo.png'),
      thumbnail: '',
      mainBoard: {
        menuKey: 'mainBoard',
        routerName: 'mainBoard',
        spanText: '메인보드',
        isSelected: false
      },
      myAdvertise: {
        menuKey: 'myAdvertise',
        routerName: 'enroll',
        spanText: '나의 광고',
        isSelected: false
      },
      enroll: {
        routerName: 'enroll',
        spanText: '광고올리기',
        isSelected: false
      },
      list: {
        routerName: 'list',
        spanText: '광고리스트',
        isSelected: false
      },
      feeInfo: {
        routerName: 'feeInfo',
        spanText: '충전 및 광고비 현황',
        isSelected: false
      },
      profile: {
        menuKey: 'profile',
        routerName: 'myInfo',
        spanText: '프로필',
        isSelected: false
      },
      myInfo: {
        routerName: 'myInfo',
        spanText: '내정보',
        isSelected: false
      },
      follower: {
        routerName: 'follower',
        spanText: '팔로워',
        isSelected: false
      }
    }
  },
  components: {
    'sub-menu': subMenu,
    'main-menu': mainMenu
  },
  methods: {
    setSelected: function (selectedRouterName) {
      this.mainBoard.isSelected = this.mainBoard.routerName === selectedRouterName
      if(selectedRouterName === 'enroll' || selectedRouterName === 'list' || selectedRouterName === 'feeInfo' || selectedRouterName === 'advertiseInfo') {
        this.myAdvertise.isSelected = true
      }else{
        this.myAdvertise.isSelected = false
      }
      this.enroll.isSelected = this.enroll.routerName === selectedRouterName
      if(selectedRouterName === 'list' || selectedRouterName === 'advertiseInfo') {
        this.list.isSelected = true
      }else{
        this.list.isSelected = false
      }
      this.feeInfo.isSelected = this.feeInfo.routerName === selectedRouterName
      if(selectedRouterName === 'myInfo' || ['followerInfo', 'followerRequest'].find(routerName => routerName === selectedRouterName) != null) {
        this.profile.isSelected = true
      }else{
        this.profile.isSelected = false
      }
      this.myInfo.isSelected = this.myInfo.routerName === selectedRouterName
      this.follower.isSelected = ['followerInfo', 'followerRequest'].find(routerName => routerName === selectedRouterName) != null
    },
    logout: function () {
      this.$router.push({name: 'signIn'})
    }
  },
  created: function () {
    // 처음 생성되었을때 selected 처리
    this.setSelected(this.$store.getters.getToRoute)
    // 썸네일 설정
    this.thumbnail = this.$store.getters.getAdUserStateValue('thumbnail') == null ? require('@/assets/img/void_icon.png') : this.$store.getters.getAdUserStateValue('thumbnail')
  },
  mounted: function () {
    // 라우트 이름 watch
    this.$store.watch(() => this.$store.getters.getToRoute, value => {
      this.setSelected(value)
    })

    // 썸네일 watch
    this.$store.watch(() => this.$store.getters.getAdUserStateValue('thumbnail'), value => {
      this.thumbnail = value
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebarWrapper{
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 224px;
}

.logoImgWrapper{
  position: relative;
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  justify-content: space-between;
  padding: 0 10%;
  margin-bottom: 24px;
  height: 64px;
  text-align: left;
}

.logoImgWrapper > .logoImg{
  width: auto;
  height: 21px;
}

.logoImgWrapper > .versionInfo{
  font-size: 10px;
}

.adUserInfoWrapper{
  display: flex;
  display: -ms-flexbox;
  height: 82px;
  background-color: #EAECF5;
}

.adUserInfoDiv{
  display: flex;
  display: -ms-flexbox;
  padding: 0 15px;
  align-items: center;
  flex: 0.7;
}

.adUserInfoDiv > img{
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.adUserInfoDiv > span{
  padding-left: 10px;
  font-weight: bold;
  font-size: 12px;
}

.logoutDiv{
  display: flex;
  display: -ms-flexbox;
  padding-right: 15px;
  justify-content: center;
  align-items: center;
  flex: 0.3;
}

.logoutDiv > span {
  cursor: pointer;
  font-size: 10px;
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/sidebar/views/sidebar.vue